export default __webpack_public_path__ + "static/media/08-city_thumb.6d695a31.png";